// src/App.jsx
import React from "react";
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { FluentProvider } from "@fluentui/react-components";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./contexts/AppContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AppRouter } from "./components/Layout/AppRouter";
import { LoginPage } from "./components/Auth/LoginPage";
import { ReviewerMode } from "./components/Contracts/ReviewerMode";
import { ApproverSigningPage } from "./components/Execution/ApproverSigningPage";
import { CrafApproverSigningPage } from "./components/Execution/CrafApproverSigningPage";
import { lexTheme } from "./styles/theme";
import "./styles/global.css";

export default function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <FluentProvider theme={lexTheme}>
        <BrowserRouter>
          <ThemeProvider>
            <AppProvider>
              <Routes>
                {/* Public reviewer route - requires authentication via MSAL */}
                <Route path="/reviewer/:id/:token" element={
                  <>
                    <AuthenticatedTemplate>
                      <ReviewerMode />
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                      <LoginPage />
                    </UnauthenticatedTemplate>
                  </>
                } />

                {/* Public approver signing route - requires authentication via MSAL */}
                <Route path="/approver/:executionId/:token" element={
                  <>
                    <AuthenticatedTemplate>
                      <ApproverSigningPage />
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                      <LoginPage />
                    </UnauthenticatedTemplate>
                  </>
                } />

                {/* Public CRAF approver signing route - requires authentication via MSAL */}
                <Route path="/craf-approver/:executionId/:token" element={
                  <>
                    <AuthenticatedTemplate>
                      <CrafApproverSigningPage />
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                      <LoginPage />
                    </UnauthenticatedTemplate>
                  </>
                } />

                {/* Protected routes */}
                <Route path="*" element={
                  <>
                    <AuthenticatedTemplate>
                      <AppRouter />
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                      <LoginPage />
                    </UnauthenticatedTemplate>
                  </>
                } />
              </Routes>
            </AppProvider>
          </ThemeProvider>
        </BrowserRouter>
      </FluentProvider>
    </MsalProvider>
  );
}
